import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const availabilityTimeslotImporterSelectors =
  importerSelectors('availabilityTimeslot.importer')

export default availabilityTimeslotImporterSelectors
